
import React from 'react';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  progress: number;
  className?: string;
  showLabels?: boolean;
  label?: string;
}

const ProgressBar = ({ progress, className, showLabels = true, label = "AI Usage" }: ProgressBarProps) => {
  return (
    <div className="space-y-2">
      {showLabels && (
        <div className="flex justify-between text-sm mb-1">
          <span>{label}</span>
          <span className="font-medium bg-gradient-to-r from-[#8B5CF6] to-[#A78BFA] dark:from-[#622bfe] dark:to-[#9549ff] bg-clip-text text-transparent">
            {progress}%
          </span>
        </div>
      )}
      <div className="h-2 rounded-full bg-gradient-to-r from-[#8B5CF6]/10 to-[#A78BFA]/10 dark:from-[#622bfe]/10 dark:to-[#9549ff]/10 backdrop-blur-sm p-[1px]">
        <div
          className={cn(
            "h-full rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#A78BFA] dark:from-[#622bfe] dark:to-[#9549ff] transition-all duration-300 ease-out",
            progress >= 80 ? "shadow-lg shadow-purple-500/20" : "",
            className
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
